import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * flag to prefetch/warm the signup app through an iframe
 */
export const FE_PREFETCH_SIGNUP_IFRAME_250328 = experiment({
  name: "FE_PREFETCH_SIGNUP_IFRAME_250328",
  identifier: "SessionToken",
  client: [
    "RETAILER",
    "VISITOR_WEB",
    "VISITOR_PERF_APP_WEB",
    "VISITOR_MIDDLEWARE",
  ],
  notifyAfter: "2025-09-28",
  defaultValue: false,
  productArea: "RETAILER_ONBOARDING",
});
